import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5b22bffe&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b22bffe')) {
      api.createRecord('5b22bffe', component.options)
    } else {
      api.reload('5b22bffe', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5b22bffe&", function () {
      api.rerender('5b22bffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/comp/ImgFallback.vue"
export default component.exports